import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';

const AccountPage = () => (
    <Fragment>
        <Header />
        <div className="container-fluid mt--6">
            <div className="row">
                <div className="col-xl-12 order-xl-1">
                    <Card />
                </div>
            </div>
        </div>
    </Fragment>
);

export default AccountPage;


// WEBPACK FOOTER //
// ./src/components/Pages/ChangePassword/index.js